import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { CLEAR_TEST_TWO_STATE, FETCH_TEST_TWO_LIST_FAILURE, FETCH_TEST_TWO_LIST_PROGRESS, FETCH_TEST_TWO_LIST_SUCCESS } from "./testTwoActions";
import {  TestTwoActions } from ".";
import { initialTestTwoState } from "./testTwo.types";


export const testTwoReducer = (
  state: IStoreState["accounting"]["testTwo"] = initialTestTwoState,
  action: TestTwoActions
) => {
  switch (action.type) {
	case FETCH_TEST_TWO_LIST_PROGRESS: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.InProgress;
	  });
	  return newState;
	}

	case FETCH_TEST_TWO_LIST_SUCCESS: {
	  const { list } = action.payload;
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Loaded;
		draftState.list = list;
	  });
	  return newState;
	}

	case FETCH_TEST_TWO_LIST_FAILURE: {
	  const newState = produce(state, (draftState) => {
		draftState.loading = LoadState.Failed;
	  });
	  return newState;
	}

	case CLEAR_TEST_TWO_STATE: {
	  return initialTestTwoState;
	}

	default:
	  return state;
	  
  }
};
